import { Injectable, ApplicationRef } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class GlobalChangeDetectionInterceptor implements HttpInterceptor {

  constructor(private appRef: ApplicationRef) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse && event.status === 200) {
          // Trigger global change detection using ApplicationRef
          this.appRef.tick(); // This forces Angular to run a full change detection cycle
          console.log('Application-wide change detection triggered');
        }
      })
    );
  }
}
